(function(module) {
    'use strict';

    function AppStoreCtrl(AppTemplate, Store, $state, $mdDialog, ListModifier, App, envService) {

        this.setDefault = () => {
            this.appTemplates = null;
            this.loading = true;
        };

        this.$onInit = () => {
            this.setDefault();
            this.getData();
        };

        this.$onChanges = ({ subAccountId }) => {
            if (subAccountId) {
                this.$onDestroy();
                this.setDefault();
                this.getData();
            }
        };

        this.$onDestroy = () => {

        };

        // Delegates to the pure filterApps() in filter-apps.js so the
        // alpha/beta rollout gating is unit-testable without angular-mocks.
        // `alpha` (achievers, workday) and `beta` (e.g. sky-news-live) are
        // independent populations; an account may hold both.
        this.filterApps = (apps) => {
            return filterApps(apps, this.account, { subAccountId: this.subAccountId });
        };

        this.getData = () => {
            return AppTemplate
                .find()
                .$promise
                .then(this.filterApps)
                .then((response) => {
                    this.loading = false;
                    this.appTemplates = response;
                    this.updateAppTemplates();
                });
        };

        this.$onInit = () => {
            this.subAccountId = Store.getCurrentSubAccountId();
            this.account = Store.getCurrentAccount();

            // defaults
            this.emptyCardStyles = {
                icon1: 'fa-plus',
                iconBackground: 'white',
                iconColor: '#0a7dff',
                iconSize: '6vw',
            };
        };

        this.updateAppTemplates = () => {
            this.groupedAppTemplates = _.groupBy(this.appTemplates, 'realm');
        };

        this.addToMyApps = (appTemplate) => {
            $state.go('root.apps.add-app', {
                appTemplateId: appTemplate.id,
                appTemplate: appTemplate,
            });
        };

        this.findAppsUsingAppTemplateId = (appTemplateId) => {
            return App
                .find({
                    filter: {
                        where: { appTemplateId },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.delete = (id) => {
            this
                .findAppsUsingAppTemplateId(id)
                .then((response) => {
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;

                    const appsUsedByTemplateCount = response && response.length;

                    //app exists
                    if (appsUsedByTemplateCount > 0) {
                        modalTitle = `You can't delete this app template as it's used by ${appsUsedByTemplateCount} of your apps.`;
                        modalConfirmationText = 'Go to "My Apps" and delete the apps that are using this custom template.';
                        modalConfirmText = 'Go to My Apps';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = () => {
                            $state.go('root.my-apps');

                        };
                    } else {
                        modalTitle = 'Are you sure you want to permanently delete this app template?';
                        modalConfirmText = 'Confirm';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (id) => {
                            this.deleteById(id);
                        };
                    }
                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: modalCancelText,
                            confirmText: modalConfirmText,
                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();
                                confirmActionFunc(id);
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                });
        };

        this.deleteById = (id) => {
            return AppTemplate
                .deleteById({ id })
                .$promise
                .then(() => {
                    ListModifier.remove(this.appTemplates, id);
                    this.updateAppTemplates();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.goToAppTemplate = (appTemplate) => {
            $state.go('root.app-store.custom-app-template-edit', { appTemplate: appTemplate, appTemplateId: appTemplate.id });
        };

        this.environment = envService.environment;

        this.onPreviewClick = (appTemplate, ev) => {
            $mdDialog.show({
                locals: {
                    appTemplate,
                },
                controller: function($scope, $mdDialog, appTemplate, $state) {
                    const { id, slug, accountId, realm, version, styles: { imageUrl } } = appTemplate;

                    this.cancel = function() {
                        $mdDialog.hide();
                    };

                    this.createApp = function() {
                        $state.go('root.app-store.add-app', {
                            appTemplateId: appTemplate.id,
                            appTemplate: appTemplate,
                        });
                        $mdDialog.hide();
                    };
                    if (realm === 'custom' && imageUrl) {
                        const baseUrl = envService.read('CUSTOM_APPS_URI');
                        this.appImageUrl = `${baseUrl}/account-${accountId}/app-template-${id}/version-${version}/${imageUrl}`;
                    } else if (realm === 'custom' && !imageUrl) {
                        this.appImageUrl = null;
                    } else {
                        const baseUrl = envService.read('APPS_URI');
                        this.appImageUrl = `${baseUrl}/${slug}/${imageUrl}`;
                    }
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/app-preview-modal/app-preview-modal.html',
                parent: angular.element('body'),
                targetEvent: ev,
                clickOutsideToClose: true,
            });

        };

        this.onAddApp = (appTemplate) => {
            $state.go('root.app-store.add-app', { appTemplateId: appTemplate.id, appTemplate });
        };

    }

    module
        .config(function($stateProvider, $translatePartialLoaderProvider) {

            $stateProvider
                .state('root.app-store', {
                    url: '/app-store',
                    data: {
                        pageTitle: 'APPS_STORE.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<app-store-component sub-account-id="$ctrl.subAccountId" searchstore="$ctrl.searchstore"></app-store-component>',
                        },
                    },
                    bodyClass: 'page--app-store',
                });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/app-store');

        })
        .component('appStoreComponent', {
            templateUrl: '/js/app-store/app-store.html',
            controller: AppStoreCtrl,
            bindings: {
                searchstore: '<searchstore',
                subAccountId: '<',

            },
        });

})(angular.module('rocket.components'));
